export default function AlertBarraGray() {
  return (
    <svg
      width='4'
      height='120px'
      viewBox='0 0 4 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M 4 0 Q 0 0 0 2 L 0 118 Q 0 120 4 120 L 4 0' fill='#828A82' />
    </svg>
  );
}
